import React, { useState } from "react"
import "./tabs-sub-header.scss"

const TABS_OPTIONS = [
    {
        name: "EVENTO",
        htmlId: "evento",
    },
    {
        name: "CONFERENCISTAS",
        htmlId: "agenda",
    },
    {
        name: "INSCRIPCIÓN",
        htmlId: "inscripcion",
    },
]

const TabsSubHeader = ({isMobile, isSecondStyle, lineColor = ''}) => {
    const [active, setactive] = useState(0)
    const [isScrollDown, setIsScrollDown] = useState(false)

    const ancla = (option) => {
        let el = document.getElementById(option);
        window.scrollTo({
            top: el?.offsetTop - (isMobile ? 90 : 200),
            behavior: "smooth",
        });
    }

    React.useEffect(() => {
        var scrollPos = 0;
        var tabs = document.getElementById("tabs").offsetTop;

        window.addEventListener('scroll', function () {
            setIsScrollDown(false)

            if ((document.body.getBoundingClientRect()).top > scrollPos) {
                setIsScrollDown(false)
                if (window.scrollY > (tabs + 200)) {
                    setIsScrollDown(true)
                }
            }
            else {
                setIsScrollDown(false)
                scrollPos = (document.body.getBoundingClientRect()).top;
            }
        });

        return () => {
            window.removeEventListener('scroll', () => { });
        }
    }, [])

    return (
        <div className={(isSecondStyle ? "f-tabs--secondary" : "f-tabs") + (isScrollDown ? " f-tabs--scrollDown" : '')} id="tabs">
            <div className="f-tabs-content">
                
                {TABS_OPTIONS.map((option, index) => {
                    return (
                        <div 
                            key={index} 
                            onClick={() => { ancla(option.htmlId); setactive(index) }}
                            style={{borderColor: lineColor}}
                            className={`f-tabs-content-tab ${active === index ? "f-tabs-content-tab--active" : ""}`}
                        >
                            {option.name}
                        </div>
                    )
                }
                    )}
            </div>
        </div>
    )
}

export default TabsSubHeader
